export default "assets/images/icons/wine-bouche-0937de0d.svg";